/**
 * Add is-in-view class to elements when they are scrolled into view
 */
export const animations = () => {
  const els = Array.from(document.querySelectorAll('.animate'));

  if (!els.length) return;

  const handleIntersection = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !entry.target.classList.contains('is-in-view')) {
        entry.target.classList.add('is-in-view');

        // disconnect observer for the element
        observer.unobserve(entry.target);
      }
    });
  };

  const observer = new IntersectionObserver(handleIntersection, {
    root: null,
    threshold: 0,
    rootMargin: '0px 0px -5% 0px',
  });

  els.forEach((el) => {
    observer.observe(el);
  });
};
